import ModalOverlay from 'builder/components/ModalOverlay'
import { useI18n } from 'builder/hooks/useI18n'
import { ButtonSize, ButtonTheme } from 'builder/components/Button'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import {
  Container,
  Content,
  ProcessWrapper,
  ProcessHeader,
  Description,
  ArrowTargetIcon,
  ActionContainer,
  CloseButton,
  ProcessContent,
  ProcessFooter,
  ActionButton,
  ActionButtonWithIcon,
} from 'builder/components/AutoTailoring/AutoTailoringModal/styles'
import {
  FreeUserDeclaration,
  TailoringSections,
} from 'builder/components/AutoTailoring/AutoTailoringModal'
import { StyledTitle, BannerImage } from './styles'
import bannerImageSrc from './assets/banner.png'

type Props = {
  handleClose: () => void
  handleClickEditManually: () => void
  handleUnlock: () => void
}

export const AutoTailoringPaywallModal = (props: Props) => {
  const { handleClose, handleClickEditManually, handleUnlock } = props
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  const buttonSize = isPhone ? ButtonSize.small : ButtonSize.default

  return (
    <ModalOverlay onClose={handleClose}>
      <Container data-testid="auto-tailoring-paywall-modal">
        <Content>
          <ProcessWrapper>
            <ProcessContent>
              <ProcessHeader>
                <StyledTitle>
                  {i18n.t('builder.job_search.auto_tailoring_paywall.title')}
                </StyledTitle>
              </ProcessHeader>
              <Description>
                {i18n.t('builder.job_search.auto_tailoring_paywall.description')}
              </Description>
              <TailoringSections />
            </ProcessContent>

            <FreeUserDeclaration />
            <ProcessFooter>
              <ActionContainer>
                <ActionButton
                  onClick={handleClickEditManually}
                  theme={ButtonTheme.ghost}
                  size={buttonSize}
                  data-testid="edit-manually-button"
                >
                  {i18n.t(
                    'builder.auto_tailoring.tailoring_model.result.free_user.edit_manually_button_text',
                  )}
                </ActionButton>
                <ActionButtonWithIcon
                  onClick={handleUnlock}
                  theme={ButtonTheme.alternative}
                  size={buttonSize}
                  data-testid="unlock-button"
                >
                  <ArrowTargetIcon />
                  {i18n.t('builder.auto_tailoring.tailoring_model.result.free_user.unlock_button')}
                </ActionButtonWithIcon>
              </ActionContainer>
            </ProcessFooter>
          </ProcessWrapper>
          <BannerImage src={bannerImageSrc} />
        </Content>
        <CloseButton onClick={handleClose} />
      </Container>
    </ModalOverlay>
  )
}
